import { supabase } from './supabase';

export async function generateCalculatorReport(
  calculatorName: string,
  inputs: Record<string, unknown>,
  result: Record<string, unknown>
): Promise<string> {
  try {
    const { data: { session } } = await supabase.auth.getSession();
    const headers: Record<string, string> = { 'Content-Type': 'application/json' };
    if (session?.access_token) headers['Authorization'] = `Bearer ${session.access_token}`;

    const response = await fetch('/.netlify/functions/claude-report', {
      method: 'POST',
      headers,
      body: JSON.stringify({ calculatorName, inputs, result }),
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.error || 'Failed to generate report');
    }

    const data = await response.json();
    return data.report;
  } catch (error) {
    console.error('Claude API error:', error);
    throw error;
  }
}
